var _rect, _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIphoneSe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "iphone_se_large_") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 54,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,10H3a3.009,3.009,0,0,0-3,3V47a3.009,3.009,0,0,0,3,3H16a3.009,3.009,0,0,0,3-3V13A3.009,3.009,0,0,0,16,10ZM7.25,12.25h4.5a.25.25,0,0,1,0,.5H7.25a.25.25,0,0,1,0-.5ZM5.5,12.125a.375.375,0,1,1-.375.375A.375.375,0,0,1,5.5,12.125Zm4,37.125a1.75,1.75,0,1,1,1.75-1.75A1.75,1.75,0,0,1,9.5,49.25ZM18,45H1V15H18Z",
    fill: "#1d1d1f"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 47.5,
    r: 1.125,
    fill: "#1d1d1f"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphoneSe);
export default __webpack_public_path__ + "static/media/iphoneSE.77a82e8371242d9aa312d30a394b458b.svg";
export { ForwardRef as ReactComponent };